import type { KnowledgeBaseDocumentTenantAnalyticsDTO } from '../../types/lac';
import { useI18n } from '../../i18n/useI18n';
import { LacDocumentsAnalyticsRow } from './LacDocumentsAnalyticsRow';

export type LacDocumentsAnalyticsTableProps = {
  rows: Array<KnowledgeBaseDocumentTenantAnalyticsDTO & { tenantName: string }>;
  showTenant: boolean;
  fileSizeLabels: { min: string; avg: string; max: string };
  emptyValue: string;
};

export function LacDocumentsAnalyticsTable({
  rows,
  showTenant,
  fileSizeLabels,
  emptyValue,
}: LacDocumentsAnalyticsTableProps) {
  const { translate } = useI18n();

  return (
    <div className="lac-documents__table-wrap liks-scrollbar">
      <table className="lac-documents__table">
        <thead>
          <tr>
            {showTenant ? (
              <th scope="col">
                {translate('lac.documents.columns.organisation')}
              </th>
            ) : null}
            <th scope="col">{translate('lac.documents.columns.documents')}</th>
            <th scope="col">{translate('lac.documents.columns.totalSize')}</th>
            <th scope="col">{translate('lac.documents.columns.fileSize')}</th>
            <th scope="col">{translate('lac.documents.columns.status')}</th>
            <th scope="col">{translate('lac.documents.columns.source')}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <LacDocumentsAnalyticsRow
              key={row.tenantName}
              row={row}
              showTenant={showTenant}
              fileSizeLabels={fileSizeLabels}
              emptyValue={emptyValue}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
